import actionTypes from "../../actionTypes";

export const setRolesAndPermissionsAction = (data) => ({
  type: actionTypes.adminTypes.rolesAndPermissionsTypes
    .SET_ROLES_AND_PERMISSIONS,
  payload: data,
});

export const setCreateRoleLoaderAction = (data) => ({
  type: actionTypes.adminTypes.rolesAndPermissionsTypes.SET_CREATE_ROLE_LOADER,
  payload: data,
});

export const setPostLoadersAction = (data) => ({
  type: actionTypes.adminTypes.rolesAndPermissionsTypes.SET_POST_ROLE_LOADER,
  payload: data,
});

export const setRoleNameCheckLoaderAction = (data) => ({
  type: actionTypes.adminTypes.rolesAndPermissionsTypes
    .SET_ROLE_NAME_CHECK_LOADER,
  payload: data,
});
